import { Box, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ReactNode } from 'react';

interface FormControlItemProps {
  children: ReactNode;
  message?: ReactNode;
  /** タイトルとmessageの間隔(theme.spacing単位)。未指定時は2(16px) */
  messageSpacing?: number;
  required?: boolean;
  title: string;
}

/** 求人フォームの1項目。タイトルと必須マークを付けて子要素を並べる */
export function FormControlItem({
  children,
  message,
  messageSpacing = 2,
  required,
  title,
}: FormControlItemProps) {
  const theme = useTheme();
  return (
    <Stack spacing={1}>
      <Stack direction="row" alignItems="center" spacing={messageSpacing}>
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Typography>{title}</Typography>
          {required && (
            <Typography color={theme.customPalette.alert}>*</Typography>
          )}
        </Stack>
        {message}
      </Stack>
      <Box>{children}</Box>
    </Stack>
  );
}
